// Copyright (c) 2022 Siemens

/**
 * @module js/DesListLibraryContentService
 */

import _ from 'lodash';
let uidToSkipMap = {};
// tree node index when loading for tree for root nodes
const parentOfRootNodelevelNdx = -1;

export const loadTreeTableData = function (result, nodeBeingExpanded, dataProvider, limit) {
    console.log('result of library content', result);
    // filter out the VMOs based on level
    const levelNdx = _.get(nodeBeingExpanded, 'levelNdx', -1);
    const parentUid = _.get(nodeBeingExpanded, 'uid', 'libraryContent');

    // Initialize tree data, results and new value of skip
    const treeData = _.get(result, 'data.data.listLibraryContent.treeDataLibraryContent');
    const totalResults = _.get(treeData, 'totalResults', 0);
    const skip = _.get(treeData, 'skip', 0);

    const response = treeData.data[parentUid];
    _.forEach(response, function (treeNode) {
        treeNode.id = treeNode.uid;
        treeNode.levelNdx = levelNdx + 1;
        treeNode.typeIconURL = treeNode.iconURL;
        // beed to overlook for this
        treeNode.parentDispName = treeNode.displayName;

    });

    /*- -*/
    nodeBeingExpanded.cursorObject = {
        startIndex: 0,
        startReached: true,
        endIndex: skip + Number.parseInt(limit),
        endReached: skip >= totalResults
    };

    const vmc = dataProvider.viewModelCollection;
    const loadedVMOs = vmc.getLoadedViewModelObjects();
    let childNodes;
    if (levelNdx === -1) {
        const filteredVMOs = _.filter(loadedVMOs, (vmo) => {
            return vmo.parentUid === parentUid;
        });

        // Filter out the response VMOs with same UID from loadedVMOs in case there are multiple server calls
        // This is only applicable for root nodes.
        childNodes = _.filter(response, (vmo) => {
            let exists = false;
            _.forEach(filteredVMOs, function (filteredVmo) {
                exists = exists || filteredVmo.uid === vmo.uid;
            });
            return !exists; //we want VMOs that do not exist in loadedVMOs. Hence returning not exists
        });

        childNodes = [...filteredVMOs, ...childNodes];
    } else {
        childNodes = response;
    }

    const lastNode = _.last(childNodes);
    if (!_.isNil(lastNode)) {
        lastNode.incompleteTail = true;
    }

    const treeNodeResult = {
        parentNode: nodeBeingExpanded,
        childNodes,
        totalChildCount: totalResults,
        startChildNdx: 0,
        skip
    };
    _.set(uidToSkipMap, parentUid, skip);

    console.log('Returning treeNodeResult LibraryContents', treeNodeResult);
    return treeNodeResult;
};

export const getSkip = (parentNode) => {
    if (parentNode.levelNdx === parentOfRootNodelevelNdx) {
        uidToSkipMap = {};
        return 0;
    }
    const id = _.get(parentNode, 'id');
    return _.get(uidToSkipMap, id, 0);
};

export const setUrnOfLibraryComponent = (vmo, selectedNodeData) => {
    const { data, dispatch } = vmo;
    data.selectedNodeUrn = selectedNodeData.uid;
    data.isParent = selectedNodeData.isExpanded;
    data.nodeBeingExpandedName = selectedNodeData.parentDispName;
    data.selectedNodeTypeName = selectedNodeData.componentType;
    data.selectedNodeId = selectedNodeData.isFolder === true ? selectedNodeData.id : null;
    data.isFolder = selectedNodeData.isFolder;
    data.isRenderListComponentOnMount = false;
    dispatch({ path: 'data', value: { ...data } });
};

export const setFirstLibraryComponentSelection = (data) => {
        const loadedVMCollection = data.dataProviders.libraryContentTreeDataProvider.getViewModelCollection();
        const vmToSelect = loadedVMCollection.getViewModelObject(0);
        if (vmToSelect) {
            data.dataProviders.libraryContentTreeDataProvider.selectionModel.setSelection(vmToSelect);
        } else {
            console.log('No record to auto select.');
        }
}

export const resetSkipValue = (vmo)=>{
    const { data, dispatch } = vmo;
    data.skip = 0;
    dispatch({ path: 'data.skip', value: 0 });
}
